var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landingpage"},[_c('router-link',{staticClass:"blue",attrs:{"to":"/login/connexion"}},[_vm._v("CONNEXION")]),_c('router-link',{staticClass:"blue",attrs:{"to":"/login/inscription"}},[_vm._v("UTILISER UN CODE")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }